import NoRows from "../../assets/svgs/NoAtri.svg";
import "./NoResultAtributtes.css";

interface NoResultAtributtesProps {
  style?: React.CSSProperties;
}

const NoResultAtributtes = ({ style }: NoResultAtributtesProps) => {
  return (
    <div className="no-result-container-details" style={style}>
      <img src={NoRows} alt="noRows" className="imgnoRows" />
      <p>Dados não finalizados. Complete para visualizar.</p>
    </div>
  );
};

export default NoResultAtributtes;
